module.exports = __webpack_public_path__ + "img/tempelli-carret-r.547b5935.svg";